import { MessageDialog, Panel } from "@bryntum/schedulerpro";
import { importDataApi } from "../../../network/network.jsx";
import { serverErrorMsg, showToast } from "../../../other/utils/utils.jsx";
import {IMPORT_TYPES} from "../../../other/constants/OtherKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { shouldShowAsyncDialog } from "../AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";

export default class UploadTab extends Panel {
  static get $name() {
    return "UploadTab";
  }

  static get type() {
    return "uploadtab";
  }

  static get configurable() {
    return {
      title: "Import",
      // Bug: When panel loads, default value of disabled is undefined and when we change value of disabled in edit record w.r.t canEdit in otherParams it changes to the next tab
      disabled: false,
      layoutStyle: {
        display:"grid"
      },
      tbar: {
        contentElementCls: "flex-col items-center",
        items : [
          {
            text: "To create a CSV template for importing your data, click “Export (CSV)” in the Export tab above.",
            type: "label",
            cls: "whitespace-pre-wrap text-center",
          },
          {
            text: "Don't change column names or column order.",
            type: "label",
            cls: "whitespace-pre-wrap text-center",
          }
        ]
      },
      items: [
        {
          text: "When importing new records (versus updating existing records), the ID field in the first column must be blank.",
          type: "label",
          cls : "mb-10 whitespace-pre-wrap text-center"
        },
        {
          ref: "filePicker",
          type: "filepicker",
          buttonConfig: {
            text: "Select a file from your device",
            align: "center",
            cls: "b-raised b-blue"
          },
          fileFieldConfig: {
            multiple: false,
            accept: "text/csv"
          },
          onChange: "up.onFilePickerChange"
        }
      ],
      strips: {
        importControls: {
          type: "toolbar",
          dock: "bottom",
          hidden: true,
          items: [{ type: "display", label: "Ready to import file name:", ref: "fileNameDisplay", flex: "1 0 auto", contentElementCls: "upload-lbl-text" }]
        }
      },
      bbar: {
        type: "toolbar",
        cls: "swivu-upload-toolbar",
        layoutStyle: {
          justifyContent: "flex-end"
        },
        items: [
          {
            ref: "actionButton",
            type: "button",
            cls: "b-raised b-blue",
            text: "Import Data",
            onAction: "up.onImport",
            disabled: true
          }
        ]
      }
    };
  }

  importEntity(file) {
    const { actionButton } = this.widgetMap;
    const { importType } = this.record;
    const selectedBoardSlug = this.context.selectedBoard.record.slug;
    // Show user feedback dialog with 'Don't show again' option
    const showDialog = shouldShowAsyncDialog('CSV_IMPORT');
    showDialog && this.context.editorHandler.openEditor(EDITOR_KEYS.asyncTaskMessageEditor, null, {record: "CSV_IMPORT"}, { useExisting: true, by: "recordType" });

    this.mask("Importing...");
    return importDataApi(file, selectedBoardSlug, importType).catch((error) => { if (error.response) showToast({ msg: serverErrorMsg(), type: "error" }); }).finally(() => {actionButton.disabled = false;this.unmask();})
  }

  onImport() {
    const { filePicker: { files } } = this.widgetMap;
    if (!files.length) return;
    this.importEntity(files[0]);
  }

  editRecord(record, context, otherParams) {
    const { onAfterImport, canEdit, onBeforeImport } = otherParams;
    this.disabled = !canEdit
    this.record = record;
    this.context = context;
    this.onAfterImport = onAfterImport;
    this.onBeforeImport = onBeforeImport;
    if (record.importType === IMPORT_TYPES.taskBudget) {
      this.widgetMap.actionButton.hidden = true;
    }
  }

  onFilePickerChange({ files }) {
    const { actionButton, importControls, fileNameDisplay } = this.widgetMap;
    actionButton.disabled = !files.length;
    importControls.hidden = !files.length;
    fileNameDisplay.value = files.length ? files[0].name : "";
    this.widgetMap.fileButton.badge = null;
    if (files.length && files[0].size > 0) {
      if (this.record.importType === IMPORT_TYPES.taskBudget) {
        this.onBeforeImport(files);
      }
    } else {
      MessageDialog.alert({
        title: "Empty File Not Allowed",
        message: "Empty file is not allowed. Please upload valid file."
      });
    }
  }
}

UploadTab.initClass();
